module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/gallery/tmb_gallery12-f8f951348a224aebce9b32623727a37e.jpg";